// removed by extract-text-webpack-plugin
module.exports = {"stock-ticker-bar":"finance_stock-ticker-bar_x","items":"finance_stock-ticker-bar_items","item":"finance_stock-ticker-bar_item","view":"finance_stock-ticker-bar_view","row":"finance_stock-ticker-bar_row","rowSmall":"finance_stock-ticker-bar_rowSmall","symbol":"finance_stock-ticker-bar_symbol","price":"finance_stock-ticker-bar_price","change":"finance_stock-ticker-bar_change","changePrice":"finance_stock-ticker-bar_changePrice","positive":"finance_stock-ticker-bar_positive","negative":"finance_stock-ticker-bar_negative","spinner":"finance_stock-ticker-bar_spinner"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-components/src/components/stock-ticker-bar/style.less
// module id = 1082
// module chunks = 0